import React from 'react';
import type { WeddingSearchHit } from '@zola/svc-web-api-ts-client';

import CoupleSearchResult from 'components/CoupleSearch/CoupleSearchResult';

import styles from './CoupleSearchResultsSection.module.less';
import NoResults from './v3/components/NoResults';

interface CoupleSearchContainerProps {
  couplesSearchResult: Array<WeddingSearchHit>;
  searchResultsRef?: React.RefObject<HTMLDivElement>;
}

const CoupleSearchResultsSection: React.FC<CoupleSearchContainerProps> = ({
  couplesSearchResult,
  searchResultsRef,
}) => {
  // Test-0: multiple link result
  // Test-1: single link result
  const coupleList = couplesSearchResult.map((couple, index) => {
    return <CoupleSearchResult key={couple.slug} result={couple} index={index} />;
  });
  const searchResultText =
    couplesSearchResult.length === 1
      ? `We found ${couplesSearchResult.length} couple`
      : `We found ${couplesSearchResult.length} couples`;
  return (
    <div className={styles.container} ref={searchResultsRef}>
      {couplesSearchResult.length === 0 && <NoResults />}
      {couplesSearchResult.length !== 0 && <p className={styles.count}>{searchResultText}</p>}
      <div className={styles.resultsContainer}>{coupleList}</div>
    </div>
  );
};

export default CoupleSearchResultsSection;
